import agentsSaga from 'Agent/AgentInformation/sagas/agentsSaga';
import hierarchySaga from 'Agent/AgentInformation/sagas/hierarchySaga';
import {all} from 'redux-saga/effects';
import newsSaga from 'Agent/AgentInformation/sagas/newsSaga';

export default function*() {
  yield all([agentsSaga(), hierarchySaga(), newsSaga()]);
}
